<template lang="pug">
  v-container
    v-layout(row, wrap)
      v-flex.mx-auto(xs12, sm8, md6)
        .accent.pa-2.text-xs-center.white--text.border-radius
          template(v-if="usuario")
            h3 Bienvenido
            h4.headline {{usuario.nombres}} {{usuario.apellidos}}
            h5 {{usuario.correo}}
            v-btn(depressed, @click="salir")
              v-icon(left) exit_to_app
              | salir
          template(v-else)
            h5 Para realizar pedido debe tener una cuenta
            v-btn(depressed, @click="iniciarIngreso") iniciar sesion
            v-btn(depressed, @click="iniciarCrear") crear cuenta
            p  
              a(@click="iniciarRecuperacion") ¿Olvidaste tu contraseña?
      app-alerta(ref="olvido", aceptar="recuperar", :dark="true" :persistent="true" :actions="true", @aceptando="recuperar")
        p Se enviará un correo para la recuperación de la contraseña.
        v-text-field(label="Email", v-model="correoRecuperacion")
      app-alerta(ref="ingreso", aceptar="ingresar", :dark="true" :persistent="true" :actions="true", @aceptando="iniciar")
        v-form(ref="ingresoForm")
          v-text-field(label="Correo", v-model="user.email", type="email")
          v-text-field(label="Contraseña",v-model="user.pass", type="password")
      v-dialog(max-width="600px", v-model="iniciarRegistro", persistent)
        v-form(ref="crearFrom")
          v-card.pa-3
            v-container.pa-0(grid-list-md)
              v-layout(row, wrap)
                v-flex(xs12)
                  v-text-field(label="Rut", v-model="nuevoUsuario.rut", :rules="[rules.required]", validate-on-blur, type="text")
                v-flex(xs6)
                  v-text-field(label="Correo", v-model="nuevoUsuario.correo", :rules="[rules.required, rules.email]", validate-on-blur, type="email")
                v-flex(xs6)
                  v-text-field(label="Confirma Correo", v-model="correo", :rules="[rules.required, rules.email]", validate-on-blur, type="email")
                v-flex(xs6)
                  v-text-field(label="Contraseña", v-model="nuevoUsuario.pass", :rules="[rules.required, rules.min6]", validate-on-blur, type="password")
                v-flex(xs6)
                  v-text-field(label="Confirma Contraseña", v-model="pass", :rules="[rules.required, rules.min6]", validate-on-blur, type="password")
                v-flex(xs6)
                  v-text-field(label="Nombres", v-model="nuevoUsuario.nombres", :rules="[rules.required]", validate-on-blur, type="text")
                v-flex(xs6)
                  v-text-field(label="Apellidos", v-model="nuevoUsuario.apellidos", :rules="[rules.required]", validate-on-blur, type="text")
                v-flex(xs12)
                  v-text-field(label="Telefono", v-model="nuevoUsuario.telefono", :rules="[rules.required]", validate-on-blur, type="text")
                  v-textarea(label="Dirección", v-model="nuevoUsuario.direccion", :rows="2", :rules="[rules.required]", validate-on-blur)
                  v-autocomplete(label="Comuna", v-model="nuevoUsuario.comunaDatos", :items="comunas", item-text="comuna", return-object, :rules="[rules.required]", validate-on-blur)
                  v-checkbox(color="primary", label="Acepto recibir notificaciones y novedades en mi correo", v-model="nuevoUsuario.acepta", :rules="[rules.required]", validate-on-blur)
                  .text-xs-right
                    v-btn(depressed, round, @click="cancelarCrear", :loading="creando") Cancelar
                    v-btn.secondary(depressed, round, @click="crear", :loading="creando") Crear Cuenta
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
export default {
  data () {
    return {
      correoRecuperacion: '',
      user: {
        email: '',
        pass: ''
      },
      nuevoUsuario: {
        correo: '',
        pass: '',
        rut: '',
        nombres: '',
        apellidos: '',
        telefono: '',
        direccion: '',
        comuna: '',
        region: '',
        comunaDatos: undefined,
        acepta: false
      },
      pass: '',
      correo: '',
      comunas: [],
      iniciarRegistro: false,
      creando: false,
      rules: {
        required: value => !!value || 'Obligatorio',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Correo no válido'
        },
        min6: val => {
          if (val !== undefined) {
            return val.length >= 8  || 'Contraseña debe ser de al menos 8 caracteres'
          } else {
            return true
          }
        }
      }
    }
  },
  watch:{
    'nuevoUsuario.comunaDatos': function (val) {
      if (val) {
        this.nuevoUsuario.comuna = val.comuna
        this.nuevoUsuario.region = val.region
      }
    }
  }, 
  mounted () {
    this.comunas = this.$store.getters['cli/comunas']
    if (this.comunas.length === 0) 
      this.$store.dispatch('cli/comunas')
      .then(() => {
        this.comunas = this.$store.getters['cli/comunas']
      })
  },
  computed: {
    usuario () {
      return this.$store.getters['usuario/user']
    }
  },
  methods: {
    salir () {
      this.$store.dispatch('usuario/out', this.$store.getters['usuario/user'].uid)
    },
    resetUser () {
      this.user = {
        email: '',
        pass: ''
      }
    },
    iniciarIngreso () {
      this.resetUser()
      this.$refs.ingreso.activo = true
    },
    iniciar () {
      this.$store.dispatch('usuario/ingreso', this.user)
      .then(res => {
        if (res.logged)
          this.$au.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
        else
          this.$store.commit('usuario/user', null)
      this.resetUser()
      this.$refs.ingreso.activo = false
      })
      .catch(e => {
        this.noted('error', e.status)
        this.resetUser()
      })
    },
    resetCrear () {
      this.nuevoUsuario = {
        correo: '',
        pass: '',
        rut: '',
        nombres: '',
        apellidos: '',
        telefono: '',
        direccion: '',
        comuna: '',
        region: '',
        comunaDatos: undefined,
        timestamp: '',
        acepta: false
      }
      this.pass = ''
      this.correo = ''
    },
    iniciarCrear () {
      this.iniciarRegistro = true
      this.resetCrear()
    },
    crear () {
      this.creando =  true
      this.nuevoUsuario.rut = this.validarRut(this.nuevoUsuario.rut)
      if (this.nuevoUsuario.pass !== this.pass) {
        this.creando = false
        this.noted('error', 'Contraseñas no coinciden')
        return
      }
      if (this.nuevoUsuario.correo !== this.correo) {
        this.creando = false
        this.noted('error', 'Correos no coinciden')
        return
      }
      if (!this.$refs.crearFrom.validate()) {
        this.creando = false
        return
      }
      this.nuevoUsuario.timestamp = this.$moment().format()
      this.$store.dispatch('usuario/crearCuenta', this.nuevoUsuario)
      .then(() => {
        this.creando = false
        this.iniciarRegistro = false
        this.noted('success', 'Cuenta Creada')
      })
      .catch(e => {
        console.log(e)
        this.noted('error', e.status)
        this.creando = false
      })
    },
    cancelarCrear () {
      this.iniciarRegistro = false
      this.resetCrear()
    },
    validarRut (rut) {
      return rut.replace(/\./g,'').replace(/-/g,'').replace(/\s/g,'').replace(/^0+/,'').toUpperCase()
    }, 
    iniciarRecuperacion () {
      this.$refs.olvido.activo = true
      this.correoRecuperacion = ''
    },
    recuperar () {
      if (this.correoRecuperacion === '') {
        this.noted('error', 'Debe ingresar un email')
        return
      }
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!pattern.test(this.correoRecuperacion)) {
        this.noted('error', 'Debe ingresar un email válido')
        return
      }
      this.$au.sendPasswordResetEmail(this.correoRecuperacion)
      .then(() => {
        this.$refs.olvido.activo = false
        this.noted('success', 'Recuperación enviada a email')
      })
      .catch(e => {
        if (e.code === 'auth/user-not-found') {
          this.$refs.olvido.activo = false
          this.noted('error', 'No existe usuario con ese email')
        } else {
          this.$refs.olvido.activo = false
          this.noted('error', 'Error recuperando contraseña')
        }
        console.error(e)
      })
    }
  }
}
</script>
